import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $GradeLevel, GradeLevel } from './grade-level';

const $ = 'KnowAndShowLevel';

export const KnowAndShowLevel = {
  KS1: tagEnum($, 1),
  KS2: tagEnum($, 2),
  KS3: tagEnum($, 3),
  KS4: tagEnum($, 4),
  KS5: tagEnum($, 5),
  KS6: tagEnum($, 6),
  KS7: tagEnum($, 7),
  KS8: tagEnum($, 8),
} as const;

export type KnowAndShowLevel = TaggedEnumUnion<typeof KnowAndShowLevel>;

export const $KnowAndShowLevel = buildStaticContext({
  [$tag]: $,
  [KnowAndShowLevel.KS1]: {
    value: KnowAndShowLevel.KS1,
    slug: 'ks-1',
    label: 'Know & Show 1',
    categoryCount: 4,
    color: $GradeLevel.describe(GradeLevel.Level1).color,
    isK2: true,
  },
  [KnowAndShowLevel.KS2]: {
    value: KnowAndShowLevel.KS2,
    slug: 'ks-2',
    label: 'Know & Show 2',
    categoryCount: 4,
    color: $GradeLevel.describe(GradeLevel.Level2).color,
    isK2: true,
  },
  [KnowAndShowLevel.KS3]: {
    value: KnowAndShowLevel.KS3,
    slug: 'ks-3',
    label: 'Know & Show 3',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level3).color,
    isK2: false,
  },
  [KnowAndShowLevel.KS4]: {
    value: KnowAndShowLevel.KS4,
    slug: 'ks-4',
    label: 'Know & Show 4',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level4).color,
    isK2: false,
  },
  [KnowAndShowLevel.KS5]: {
    value: KnowAndShowLevel.KS5,
    slug: 'ks-5',
    label: 'Know & Show 5',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level5).color,
    isK2: false,
  },
  [KnowAndShowLevel.KS6]: {
    value: KnowAndShowLevel.KS6,
    slug: 'ks-6',
    label: 'Know & Show 6',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level6).color,
    isK2: false,
  },
  [KnowAndShowLevel.KS7]: {
    value: KnowAndShowLevel.KS7,
    slug: 'ks-7',
    label: 'Know & Show 7',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level7).color,
    isK2: false,
  },
  [KnowAndShowLevel.KS8]: {
    value: KnowAndShowLevel.KS8,
    slug: 'ks-8',
    label: 'Know & Show 8',
    categoryCount: 9,
    color: $GradeLevel.describe(GradeLevel.Level8).color,
    isK2: false,
  },
} as const);
